import React, {  } from "react";
import { Route, Switch } from "react-router-dom";
import Search from "./Search";
import {withTranslation} from "react-i18next";
import { SentryRoute } from "index";

const SearchRouter = () => {
  return (
    <Switch>
      <SentryRoute exact path="/search" component={Search} />
    </Switch>
  );
};

export default withTranslation()(SearchRouter)
